import AbstractPage from 'abstracts/AbstractPage';
import ProjectsHeader from './ProjectsHeader';


export default class Projects extends AbstractPage {
	
	constructor() {
		super();
	}
}

